<template>
    <el-container class="container">
      <el-header class="stay_header" height="650px">
        <el-row :gutter="20">
          <el-col :span="3">
            <div class="stay_title">单元滞留信息</div>
          </el-col>
        </el-row>
        <el-table  border="true" stripe :data="lineStateStay"  style="width: 100%" height="650px"
                   :header-cell-style="{textAlign: 'center',background:'#1A73E8',color:'white',fontSize:'20px'}"
                   :cell-style="{ textAlign: 'center' }">
          <el-table-column type="index" label="序号" highlight width="80" />
          <el-table-column property="wujian_id" label="物件番号" min-width="100" />
          <el-table-column property="lot_no" label="批号" min-width="100" />
          <el-table-column property="unit_type" label="单元类型" min-width="250" />
          <el-table-column property="unit_no" label="窗番" min-width="150" />
          <el-table-column property="stage_name" label="滞留工站" min-width="150" >
            <template v-slot="scope">
              <div :style="{color:scope.row.color}">
                {{ scope.row.stage_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column property="delay_time" label="滞留时长" min-width="100" >
            <template v-slot="scope">
              <div style="color:red">
                {{scope.row.delay_time }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-header>
    </el-container>
</template>

<script>
export default {
  name: "AssemblyPage5",
  props: {
    parentData:Object
  },
  data() {
    return {
      lineStateStay:[]
    }
  },computed: {

  },methods:{
    getLineStateStayData(){
      this.$axios.post('am/lineStates/getLineStatesStay', this.parentData).then(response => {
        let res = response.data
        this.lineStateStay = res.data.lineStateStay;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
  },created() {
    this.getLineStateStayData()
  }
}
</script>

<style scoped>
.stay_header {
  width: 99%;
  height: 100%;
  margin-left: 7px;
  border: 1px #a1a1a1 solid;
  border-radius: 8px;
  padding: 5px;
  overflow-x: hidden;
  overflow-y: hidden;
}

.stay_title {
  margin-left: 6px;
  width: 300px;
  border-radius: 10px;
  font-weight: bold;
  font-size: 30px;
  text-align: center;
  background-color: red;
  color: white
}
</style>